/* eslint-disable jsdoc/check-param-names */
import { ActionBrick, registerBrick, BrickContext } from 'olympe';
import { getLogger } from '@olympeio/core';

export default class CostCenterSearchMapping extends ActionBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string[]} costCenterIds
     * @param {boolean} isPurchGroup
     * @param {string[]} approvers
     * @param {string[]} agents
     * @param {function(): void} forwardEvent
     * @param {function(string): void} setFilterString
     */
    update($, [costCenterIds, isPurchGroup, approvers, agents], [forwardEvent, setFilterString]) {
        const logger = getLogger('CostCenterSearchMapping');

        try {
            const filter = [`IdNo eq '01'`];
            const approverFilterList = [];

            if (costCenterIds?.length > 0) {
                if (isPurchGroup) {
                    const purchGroupFilterList = [];

                    costCenterIds.forEach((costCenterId) => {
                        purchGroupFilterList.push(`PurchGroup eq '${costCenterId}'`);
                    });

                    const purchGroupFilter = purchGroupFilterList.join(' or ');

                    filter.push(`(${purchGroupFilter})`);
                } else {
                    const costCenterFilterList = [];

                    costCenterIds.forEach((costCenterId) => {
                        costCenterFilterList.push(`CostElementId eq '${costCenterId}'`);
                    });

                    const costCenterFilter = costCenterFilterList.join(' or ');

                    filter.push(`(${costCenterFilter})`);
                }
            }

            if (approvers?.length > 0) {
                approvers.forEach((approver) => {
                    approverFilterList.push(`SearchTerm eq '${approver}'`);
                });
            }

            if (agents?.length > 0) {
                agents.forEach((agent) => {
                    approverFilterList.push(`SearchTerm eq '${agent}'`);
                });
            }

            if (approvers?.length > 0 || agents?.length > 0) {
                const approverFilter = approverFilterList.join(' or ');

                filter.push(`(${approverFilter})`);
            }

            const returnFilterString = `${filter.join(' and ')}`;

            setFilterString(returnFilterString);
            forwardEvent();
        } catch (error) {
            const message = typeof error === 'string' ? error : error.message;
            logger.error(message);
        }
    }
}

registerBrick('01905dba2330278a199d', CostCenterSearchMapping);
